<template>
  <div class="row">
    <div class="col-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateCertification"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillCertificationForm="fillCertificationForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.sub_category_and_tasks')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              :generalTaskPercentage="getPercentage"
              @on-validated="onStepValidated"
              @fillCertificationForm="fillCertificationForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              3.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-11 table-responsive">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ certificationForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.description') }}:</strong>
                        </h6>
                        <template v-if="certificationForm.description">
                          {{ certificationForm.description }}
                        </template>
                        <el-tag class="mt-2" v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.type_of_qualification')
                            }}:</strong
                          >
                        </h6>
                        <el-tag type="info">{{
                          certificationForm.qualification_type
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.type_of_capture') }}:</strong
                          >
                        </h6>
                        <el-tag type="info">{{
                          certificationForm.type
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.record_quantity') }}:</strong
                          >
                        </h6>
                        {{ certificationForm.total_records }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.records_name') }}:</strong
                          >
                        </h6>
                        <template v-if="certificationForm.record_name">
                          {{ certificationForm.record_name }}
                        </template>
                        <el-tag class="mt-2" v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.general_percentage_by_task')
                            }}:</strong
                          >
                        </h6>
                        <template v-if="certificationForm.discount_percentage">
                          {{ certificationForm.discount_percentage }} %
                        </template>
                        <el-tag class="mt-2" v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(
                            business, index
                          ) in certificationForm.business_name"
                          :key="index"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_profiles2')
                            }}:</strong
                          >
                        </h6>
                        <template
                          v-if="certificationForm.roles_name.length > 0"
                        >
                          <span
                            v-for="(
                              role, index
                            ) in certificationForm.roles_name"
                            :key="index"
                          >
                            <el-tag type="info">{{ role }}</el-tag>
                          </span>
                        </template>
                        <el-tag v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.associated_users2') }}:</strong
                          >
                        </h6>
                        <template
                          v-if="certificationForm.users_name.length > 0"
                        >
                          <span
                            v-for="(
                              user, index
                            ) in certificationForm.users_name"
                            :key="index"
                          >
                            <el-tag type="info">{{ user }}</el-tag>
                          </span>
                        </template>
                        <el-tag v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{ $t('common_words.files') }}:</strong>
                        </h6>
                        <template
                          v-if="
                            certificationForm.fileList &&
                            certificationForm.fileList.length > 0
                          "
                        >
                          <el-tag
                            type="info"
                            v-for="(
                              fileCertification, index
                            ) in certificationForm.fileList"
                            :key="index"
                          >
                            {{ fileCertification }}
                          </el-tag>
                        </template>
                        <el-tag v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table mb-4">
                          <strong
                            >{{
                              $t('common_words.sub_associated_category')
                            }}:</strong
                          >
                        </h6>
                        <div
                          v-if="
                            certificationForm.sub_category_names &&
                            certificationForm.sub_category_names.length > 0
                          "
                        >
                          <table aria-describedby="tabla-calidad" class="table">
                            <thead>
                              <tr>
                                <td></td>
                                <td>{{ $t('common_words.mayus_tasks') }}</td>
                                <td>{{ $t('common_words.mayus_type') }}</td>
                                <td>
                                  {{
                                    $t('common_words.mayus_associated_value')
                                  }}
                                </td>
                                <td>
                                  {{ $t('common_words.product_percentage') }}
                                </td>
                                <td>
                                  {{ $t('common_words.value_percentage') }}
                                </td>
                                <td>
                                  {{ $t('common_words.photo_questionmark') }}
                                </td>
                                <td>
                                  {{ $t('common_words.required_questionmark') }}
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(index, order) in orderData(
                                  certificationForm.subcategoryOrder
                                )"
                                :key="order"
                              >
                                <td>
                                  <el-tag
                                    style="height: auto"
                                    type="info"
                                    v-if="
                                      certificationForm.sub_category_names[
                                        index
                                      ]
                                    "
                                  >
                                    <span
                                      v-tooltip.top-center="
                                        certificationForm.sub_category_names[
                                          index
                                        ].length > 15
                                          ? `${order} - ${certificationForm.sub_category_names[index]}`
                                          : ``
                                      "
                                    >
                                      {{ $t('common_words.order') }}: {{ order
                                      }}<br />
                                      {{ $t('common_words.name') }}:
                                      {{
                                        certificationForm.sub_category_names[
                                          index
                                        ].substring(0, 15)
                                      }}{{
                                        certificationForm.sub_category_names[
                                          index
                                        ].length > 15
                                          ? `...`
                                          : ``
                                      }}<br />
                                      {{ $t('common_words.general') }}:
                                      {{
                                        certificationForm.isGeneral[index]
                                          ? 'Si'
                                          : 'No'
                                      }}<br />
                                      {{ $t('common_words.percentage') }}:
                                      {{
                                        getFormatNumber(
                                          certificationForm.valuePercentage[
                                            index
                                          ]
                                        )
                                      }}%
                                    </span>
                                  </el-tag>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, orderTask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-if="
                                        certificationForm.task_names[taskIndex]
                                      "
                                      :key="orderTask"
                                    >
                                      <span
                                        v-tooltip.top-center="
                                          certificationForm.task_names[
                                            taskIndex
                                          ].length > 32
                                            ? `${orderTask} - ${certificationForm.task_names[taskIndex]}`
                                            : ``
                                        "
                                      >
                                        {{ orderTask }}
                                        -
                                        {{
                                          certificationForm.task_names[
                                            taskIndex
                                          ].substring(0, 32)
                                        }}{{
                                          certificationForm.task_names[
                                            taskIndex
                                          ].length > 32
                                            ? `...`
                                            : ``
                                        }}
                                      </span>
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, order) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-if="
                                        certificationForm.calification_type[
                                          taskIndex
                                        ]
                                      "
                                      class="d-flex align-items-center size-cell"
                                      :key="order"
                                    >
                                      {{
                                        certificationForm.calification_type[
                                          taskIndex
                                        ]
                                      }}
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, orderTask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-tooltip.top-center="
                                        showOptionTask(
                                          certificationForm.task_values[
                                            taskIndex
                                          ]
                                        ).length > 60
                                          ? showOptionTask(
                                              certificationForm.task_values[
                                                taskIndex
                                              ]
                                            )
                                          : ``
                                      "
                                      class="d-flex align-items-center size-cell"
                                      :key="orderTask"
                                      v-if="
                                        certificationForm.task_values[
                                          taskIndex
                                        ] &&
                                        certificationForm.calification_type[
                                          taskIndex
                                        ] &&
                                        ['Única', 'Múltiple'].includes(
                                          certificationForm.calification_type[
                                            taskIndex
                                          ]
                                        )
                                      "
                                    >
                                      {{
                                        showOptionTask(
                                          certificationForm.task_values[
                                            taskIndex
                                          ]
                                        ).substring(0, 60)
                                      }}
                                      {{
                                        showOptionTask(
                                          certificationForm.task_values[
                                            taskIndex
                                          ]
                                        ).length > 60
                                          ? `...`
                                          : ``
                                      }}
                                    </p>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-else-if="
                                        certificationForm.calification_type[
                                          taskIndex
                                        ] == 'Subjetiva'
                                      "
                                    >
                                      <label class="row subject-calification">
                                        <div class="px-0 mr-1">
                                          <el-tag closable type="info">
                                            0
                                          </el-tag>
                                        </div>
                                        ...
                                        <div class="px-0 mr-1">
                                          <el-tag closable type="info">
                                            10
                                          </el-tag>
                                        </div>
                                        ...
                                        <div class="px-0 mr-1">
                                          <el-tag closable type="info">
                                            NA
                                          </el-tag>
                                        </div>
                                      </label>
                                    </p>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-else-if="
                                        ['Numérica', 'Texto'].includes(
                                          certificationForm.calification_type[
                                            taskIndex
                                          ]
                                        )
                                      "
                                    >
                                      <label
                                        class="font-weight-light"
                                        style="font-size: 14px"
                                      >
                                        {{ showRangeSelected(taskIndex) }}
                                      </label>
                                    </p>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-else-if="
                                        certificationForm.task_values[
                                          taskIndex
                                        ] &&
                                        certificationForm.calification_type[
                                          taskIndex
                                        ] &&
                                        [
                                          'Fuente de Datos',
                                          'Fuente de Datos Múltiple',
                                        ].includes(
                                          certificationForm.calification_type[
                                            taskIndex
                                          ]
                                        )
                                      "
                                    >
                                      {{
                                        certificationForm.data_source_selected[
                                          taskIndex
                                        ]
                                      }}
                                    </p>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-else-if="
                                        ['Numérica', 'Texto'].includes(
                                          certificationForm.calification_type[
                                            taskIndex
                                          ]
                                        )
                                      "
                                    >
                                      <label
                                        class="font-weight-light"
                                        style="font-size: 14px"
                                      >
                                        {{ showRangeSelected(taskIndex) }}
                                      </label>
                                    </p>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-else-if="
                                        ['Fecha', 'Hora', 'Objetiva'].includes(
                                          certificationForm.calification_type[
                                            taskIndex
                                          ]
                                        )
                                      "
                                    >
                                      {{ $t('common_words.does_not_apply') }}
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, orderTask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-if="true"
                                      class="d-flex align-items-center size-cell"
                                      :key="orderTask"
                                    >
                                      {{
                                        getFormatNumber(
                                          certificationForm.taskDcto[taskIndex]
                                        )
                                      }}%
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, orderTask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-if="true"
                                      class="d-flex align-items-center size-cell"
                                      :key="orderTask"
                                    >
                                      {{
                                        Number(
                                          getFormatNumber(
                                            certificationForm.taskPercentage[
                                              taskIndex
                                            ]
                                          )
                                        )
                                      }}%
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, orderTask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-if="
                                        certificationForm.photo_required[
                                          taskIndex
                                        ] !== undefined
                                      "
                                      class="d-flex align-items-center size-cell"
                                      :key="orderTask"
                                    >
                                      {{
                                        certificationForm.photo_required[
                                          taskIndex
                                        ]
                                          ? 'Si'
                                          : 'No'
                                      }}
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, ordertask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-if="
                                        certificationForm.is_required[
                                          taskIndex
                                        ] !== undefined
                                      "
                                      class="d-flex align-items-center size-cell"
                                      :key="ordertask"
                                    >
                                      {{
                                        certificationForm.is_required[taskIndex]
                                          ? 'Si'
                                          : 'No'
                                      }}
                                    </p>
                                  </template>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <el-tag
                          type="warning"
                          v-if="
                            !certificationForm.sub_category_names ||
                            certificationForm.sub_category_names.length == 0
                          "
                          >{{
                            $t('common_words.no_sub_associated_category')
                          }}</el-tag
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { showContinue } from 'src/util/Util.js';
import { Slider } from 'element-ui';
import FirstStep from './steps/FirstStep.vue';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinNumbers from 'src/util/mixinNumbers';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
    [Slider.name]: Slider,
  },

  computed: {
    getPercentage() {
      const value = Number(this.certificationForm.discount_percentage);

      return value ? value : 0;
    },
  },

  data() {
    return {
      title: '',
      certificationForm: {
        name: null,
        description: null,
        capture_type: null,
        qualification_type: 'web',
        total_records: null,
        record_name: null,
        discount_percentage: 0,
        business_name: null,
        roles_name: [],
        users_name: [],
        subcategoryOrder: [],
        sub_category_names: [],
        sub_category_ids: [],
        task_ids: [],
        task_names: [],
        task_order: [],
      },
      wizardModel: {},
    };
  },

  mixins: [MixinPermissions, MixinMasters, MixinNumbers, MixinMenu],

  methods: {
    getFormatNumber(value) {
      return Formatter.formatNumber(Number(value));
    },

    showOptionTask(items) {
      return `["${items.join('", "')}"]`;
    },

    orderData(data) {
      let array = [];
      try {
        array = Object.entries(data);
      } catch (error) {
        //
      }

      array.sort((a, b) => a[1] - b[1]);
      const sortedObj = Object.fromEntries(
        array.map(([value, key]) => [key, value])
      );

      return sortedObj;
    },

    getOrderTask(indexSubcategory) {
      let a = 0;
      const response = [];
      while (a < this.certificationForm.tasks_number[indexSubcategory]) {
        response.push(`${indexSubcategory}-${a}`);
        a++;
      }

      response.sort((a, b) => a - b);

      const array = Object.entries(this.certificationForm.task_order);
      const orderTask = {};
      array.forEach((data) => {
        if (response.includes(data[0])) {
          orderTask[data[0]] = data[1];
        }
      });

      return orderTask;
    },

    cleanAllSteps() {
      this.$refs.firstStep.model = {
        ...this.$refs.firstStep.initialModel,
        total_records: 1,
        qualification_type: 'web',
      };
      this.$refs.secondStep.cleanStep();
    },

    showRangeSelected(index) {
      try {
        return (
          'Min: ' +
          this.roundNumber(
            this.certificationForm.task_numeric_values[index][0],
            2
          ) +
          ' - Max: ' +
          this.roundNumber(
            this.certificationForm.task_numeric_values[index][1],
            2
          )
        );
      } catch (error) {
        return '';
      }
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillCertificationForm(ref, others) {
      this.certificationForm = Object.assign(
        {},
        this.certificationForm,
        this.$refs[ref].model
      );

      if (others)
        this.certificationForm = Object.assign(
          {},
          this.certificationForm,
          others
        );
    },

    storeUpdateCertification() {
      this.showHideLoading(true);
      this.certificationForm.route = 'certifications/admin';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.certificationForm.capture_type =
            this.certificationForm.capture_type === 'Por Lote' ? '1' : '2';
          this.certificationForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;

          if (isset(this.certificationForm.evidence)) {
            if (!isset(this.certificationForm.fileList)) {
              this.certificationForm.evidence = null;
            }
          }

          Axios.updateMaster(this.certificationForm)
            .then((response) => {
              this.showHideLoading();

              if (isset(this.$refs.firstStep.model.fileList)) {
                this.$refs.firstStep.submitUpload();
              }

              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/certifications/admin',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.certificationForm)
            .then((response) => {
              this.showHideLoading();

              if (isset(this.certificationForm.fileList)) {
                this.$refs.firstStep.uploadData.idCertification =
                  response.data.data.id;
                this.$refs.firstStep.submitUpload();
              }

              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/certifications/admin',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('certifications');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('certifications');
  },
};
</script>
